import { AutomaticIntegrationEntity } from "../../entity/AutomaticIntegrationEntity";
import { HttpAdapter } from "../../main/adapters/HttpAdapter";

export class AutomaticIntegration {
    HttpAdapter = new HttpAdapter();
    baseUrl = `${publicSettings.aws.baseUrls.accounting}/accounting/manager-integration`;

    async get({ accountingId } = {}) {
        try {
            const response = await this.HttpAdapter.call(
                `${this.baseUrl}/get-by-accountingid`,
                { accountingId }
            );
            const props = response?.[0] || {};
            const entity = AutomaticIntegrationEntity.restore(props);
            return entity;
        } catch (err) {
            return err;
        }
    }

    async getBySystem({ accountingId, system } = {}) {
        try {
            const response = await this.HttpAdapter.call(
                `${this.baseUrl}/get-by-accountingid`,
                { accountingId }
            );
            const responseSystem = response?.find(
                (item) => item?.system === system
            );
            const props = responseSystem || {};
            const entity = AutomaticIntegrationEntity.restore(props);
            return entity;
        } catch (err) {
            return err;
        }
    }

    /**
     * Todas as conexões da contabilidade, cruas, para quem precisa escolher entre elas.
     *
     * `null` quando a consulta falha (rede, 401, 5xx: a resposta de erro chega como objeto), para
     * não ser confundida com "não tem conexão" e a tela não mandar refazer a integração.
     */
    async listByAccounting({ accountingId } = {}) {
        try {
            const response = await this.HttpAdapter.call(
                `${this.baseUrl}/get-by-accountingid`,
                { accountingId }
            );
            return Array.isArray(response) ? response : null;
        } catch (err) {
            return null;
        }
    }

    async create({ accountingId, system, connection } = {}) {
        if (!accountingId || !system || !connection) return false;
        try {
            const response = await this.HttpAdapter.call(
                `${this.baseUrl}/save`,
                {
                    accountingId,
                    system,
                    connection
                }
            );
            return response;
        } catch (err) {
            return err;
        }
    }

    async update({ accountingId, _id, system, connection } = {}) {
        if (!accountingId || !system || !connection) return false;
        try {
            const response = await this.HttpAdapter.call(
                `${this.baseUrl}/save`,
                {
                    _id,
                    accountingId,
                    system,
                    connection
                }
            );
            return response;
        } catch (err) {
            return err;
        }
    }

    async remove({ _id, accountingId, system, connection } = {}) {
        if (!_id || !accountingId || !system || !connection) return false;
        try {
            const response = await this.HttpAdapter.call(
                `${this.baseUrl}/save`,
                {
                    _id,
                    accountingId,
                    system,
                    connection
                }
            );
            return response;
        } catch (err) {
            return err;
        }
    }

    async update({ _id, accountingId, system, connection } = {}) {
        if ((!_id, !accountingId || !system || !connection)) return false;
        try {
            const response = await this.HttpAdapter.call(
                `${this.baseUrl}/save`,
                {
                    _id,
                    accountingId,
                    system,
                    connection
                }
            );
            return response;
        } catch (err) {
            return err;
        }
    }
}
